if (!window.reaProductVideoInit) {
  window.reaProductVideoInit = true;

  // Plain <video> element, present in the initial HTML — no deferred-media,
  // no <template> clone, no covering layer to fight with. Just plays/pauses
  // as it enters/leaves the viewport so it doesn't burn CPU/battery
  // off-screen, and re-confirms muted/playsinline defensively.
  document.querySelectorAll('.rea-product-video__el').forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      { threshold: 0.25 }
    );
    observer.observe(video);
  });
}
